import { NavigationDirection } from '@/models/navigation-direction';
import store from '@/store';
import BasicComponent from './BasicComponent';

class Circle extends BasicComponent {
  _stepName: string;

  constructor(stepName: string, component: any = {}) {
    super(component);
    this._stepName = stepName;

    this._methods = {
      resetNextSteps() {
        const formKeys = Object.keys(this.getFormData);
        const index = formKeys.indexOf(stepName);
        if (index > -1) {
          const nextSteps = formKeys.slice(index + 1);
          nextSteps.forEach((step: string) => {
            this.setFormData(null, step);
          });
        }
      },

      setFormData(value: any, step = stepName) {
        store.dispatch('setToForm', {
          key: step,
          value,
        });
      },

      setValue(value: any, next = false) {
        if (!value?.length) value = null;
        if (value !== this.getFormData[stepName]) this.resetNextSteps();
        this.setFormData(value);

        if (next) {
          setTimeout(() => {
            store.commit('navigateToDirection', NavigationDirection.NEXT);
          }, 300);
        }
      },
    };

    this._computed = {
      getActiveList() {
        const items = this.$store.getters.getSelectedCoffeeList;
        let list: string[] = [];
        items.forEach((item: any) => {
          Object.keys(item[stepName]).forEach((key) => {
            if (item[stepName][key]) {
              list.push(key);
            }
          });
        });

        list = [...new Set(list)];
        return list.sort().reverse();
      },
      getFormData() {
        return this.$store.getters.getFormData;
      },
      getThisData() {
        return this.$store.getters.getFormData[stepName];
      },
      mod() {
        return this.$store.getters.getMod;
      },
      steps() {
        return this.$store.getters.stepsContent;
      },
      step() {
        return this.$store.getters.stepsContent[stepName];
      },
      circleSize() {
        return this.$store.getters.circleSize;
      },
    };

    this.addImplementKeys(['methods', 'computed']);
  }
}

export default Circle;
